import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridToolbar,
} from "@mui/x-data-grid";
import { Box } from "@mui/material";
import * as React from "react";

import User from "../../stores/UserStore";
import NocsRequests from "../../stores/NocsRequestsStore";

import View from "../../assets/view.svg";
import DeleteIcon from "../../assets/Delete.svg";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { TextField, TextFieldProps } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";
import CardsPopup from "../MoveOutTerminationTabs/CardsPopup";
import Modal from "@mui/material/Modal";
import SocialCaseModal from "./SocialCaseModal";
import PDCModal from "./PDCModal";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import { toJS } from "mobx";
import nocsRequestsStore from "../../stores/NocsRequestsStore";
import cardsStore from "../../stores/CardsStore";
import { Spinner } from "../SpinnerRaw/SpinnerRaw";
import "../DataGrid/style.css";
import NOCMobileDataGrid from "./NOCMobileGrid";
import paymentPlanStore from "../../stores/PaymentPlanStore";
import Thankyou from "../SocialCaseTbas/Thankyou";
import CancelRequest from "../CancelRequest/CancelRequest";
import MoveinRequestUpdations from "../MoveinRequestUpdations/MoveinRequestUpdations";
import {
  TabContainer,
  ThankyouHeader,
  ThankyouMessage,
} from "../../components/SocialCaseTbas/Social.styled";
import thanks from "../../assets/thanks.svg";
import { useNavigate } from "react-router-dom";
import HappyMeterStore from "../../stores/HappyMeter";
import pdf from "../../assets/PdfIcon.svg";
import AccountsNotifications from "../../stores/AccountsNotificationsStore";
import DeleteModal from "../Profile/DeleteModal";
import moment from "moment";
import Inprogress from '../../assets/table/inprogress.png'
import InprogressAr from '../../assets/table/progressar.png'
import InprogressHi from '../../assets/table/inprogresshi.png'
import Started from '../../assets/table/started.png'
import StartedAr from '../../assets/table/startedar.png'
import StartedHi from '../../assets/table/staetedhi.png'
import Completed from '../../assets/table/completed.png'
import CompletedAr from '../../assets/table/completedar.png'
import CompletedHi from '../../assets/table/completedhi.png'
import { NotifySuccess } from "../../utils/ShowSuccess";
import { NotifyError } from "../../utils/ShowError";
interface Obj {
  [key: string]: string | {} | [];
}

const NocGrid = (props?: any) => {
  const [pageSize, setPageSize] = useState<number>(5);
  const [loading, setLoading] = useState(false);
  const [cardsPopupModal, setCardsPopupModal] = useState(false);
  const [socialCaseModalOpen, setSocialCaseModalOpen] = useState(false);
  const [cancelRequestModalOpen, setCancelRequestModalOpen] = useState(false);
  const [moveinUpdateModelOpen, setMoveinUpdateModalOpen] = useState(false);
  const [pdcModalOpen, setPDCModalOpen] = useState(false);
  const [fromValue, setFromValue] = useState<any | null>(moment(moment(moment(Date.now()).format("YYYY-MM-DD")).clone().subtract(90, 'days').toDate()).format("YYYY / MM / DD"));
  const [toValue, setToValue] = useState<Date | null>(new Date());
  const [dateValue, setDateValue] = useState<Date | null>(new Date());
  const navigate = useNavigate();
  const [statusId,setStatusId] = useState<any>(0)
  const [rows, setRows] = useState<Object[]>([]);
  const [columns, setColumns] = useState<GridColDef[]>([]);
  const [cancelRequestNumber,setCancelRequestNumber] = useState<any>("")
  const [isLargeScreen, setIsLargeScreen] = React.useState(false);
  const [lastBillingId, setLastBillingId] = useState<any>("");
  const [moveinData, setMoveinData] = useState<any>();
  const [moveinCaseId, setMoveinCaseId] = useState<any>();
  const [caseReasons, setCaseReasons] = useState<Array<any>>([]);

  React.useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handlegetBankDetails = async () => {
    await paymentPlanStore?.getBankDetails({ errorId: "Getbank" })
  }
  useEffect(() => {
    handlegetBankDetails();
  }, [])
  useEffect(() => {
    const pdcCaseId = localStorage?.getItem("pdcId")
    if (pdcCaseId) {
      handlePDCModalOpen(pdcCaseId)
    }
  }, [])
  const [socialCaseStatus, setsocialCaseStatus] = useState();
  const handleSocialCaseModalOpen = async (requestNumber: string, status: any, statusId = 0) => {
    setStatusId(statusId);
    setsocialCaseStatus(status)
    await NocsRequests.getCaseDetails({
      errorId: "getCaseDetailsError",
      data: requestNumber,
    });
    setSocialCaseModalOpen(true);
  };
  const handleSocialCaseModalClose = () => setSocialCaseModalOpen(false);
  const [pdccaseNo, setCaseNo] = useState<any>()
  const handlePDCModalOpen = async (caseNumber: string) => {
    await NocsRequests.getPDCDetails({
      errorId: "getPDCDetailsError",
      data: caseNumber,
    });
    setCaseNo(caseNumber);
    setPDCModalOpen(true);
  };
  const [delModalOpen, setDELModalOpen] = useState(false);
  const [paramCase, setCaseId] = useState<any>()
  const handleDeletePDCModalOpen = (caseNumber: string) => {
    setDELModalOpen(true);
    setCaseId(caseNumber)
  }
  const [delLoader, setDelLoader] = useState(false);
  const deletePdc = async () => {
    setDelLoader(true);
    const res = await NocsRequests.deletePdc({
      errorId: "getPDCDetailsError",
      data: paramCase,
    });
    if (res?.result?.output?.status == "S") {
      setDELModalOpen(false);
      setDelLoader(false)
    }
    setDelLoader(false)
  }
  const closeDelModal = () => {
    setDELModalOpen(false)
  }
  const [payLoader, setPayLoader] = useState(false);
  const handlePay = async (caseNumber: string) => {
    setPayLoader(true);
    await handleGetPDCServiceAccountList(caseNumber);
    await handleGetPDCConnectorAccountList(caseNumber);
    await NocsRequests.getPDCDetails({
      errorId: "getPDCDetailsError",
      data: caseNumber,
    });
    setPayLoader(false);
    setCardsPopupModal(true);
  }
  const handlePDCModalClose = () => setPDCModalOpen(false);

  const handleDate = (newVal: Date | null) => {
    setDateValue(newVal);
  };

  const handleFromChange = (newVal: Date | null) => {
    setFromValue(newVal);
  };

  const handleToChange = (newVal: Date | null) => {
    setToValue(newVal);
  };

  const handleGetPDCServiceAccountList = async (caseNo: string) => {
    await NocsRequests.getPDCServiceAccountList({
      errorId: "getPDCServiceAccountListError",
      data: caseNo,
    });
  };

  const handleGetPDCConnectorAccountList = async (caseNo: string) => {
    await NocsRequests.getPDCConnectorAccountList({
      errorId: "getPDCServiceAccountListError",
      data: caseNo,
    });
  };
  const downloadBillPDF = async (id: string,referenceId:any) => {
    setLoading(true);
    const data = { id,referenceId };
    const res = await AccountsNotifications?.downloadRecentNOC({
      errorId: "getFileError",
      data,
    });
    if (res) {
      setLoading(false);
    }
  };
  const loadTable = async () => {
    setLoading(true);

    switch (props.index) {
      case 0:
        await NocsRequests.getValidNocs({ errorId: "getValidNocsError" });
        setColumns(columnsValidNocs);

        const validFilter = NocsRequests.nocs
          ? NocsRequests.nocs.filter((payment) => payment.status == "Completed")
          : [];

        setRows(validFilter);
        break;


      default:
        break;
    }

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };
  const handleCloseCardsPopupModal = () => {
    setCardsPopupModal(false);
  };
  const handlePayNowClicked = async () => {
    setCardsPopupModal(true);
  };
  const handleMakePayment = async (cardData: any) => {
    let temp = {
      ...cardData,
      tokenNumber: NocsRequests.pdcDetails.caseNo,
      totalAmountToPay: NocsRequests.pdcDetails.totalAmount,
      totalAmountSelected: NocsRequests.pdcDetails.currentAmount,
      status: NocsRequests.pdcDetails.status,
      corelationID: NocsRequests.pdcDetails.corelationID,
    };

    const responseee = await cardsStore?.pdcPAymentsCard({ errorId: "payBillError", data: temp });
    if (responseee?.message == "Success") {
      window.open(responseee?.result?.redirectUrl, "_self");
      localStorage.setItem('pdcId', pdccaseNo)
    }

  };
  const [saveloader, setSaveloader] = useState(false);
  const [thankeTitle, setThanksTitle] = useState("")
  const [thanksModal, setThanksModal] = useState(false)
  const handleSave = async (data: any) => {
    setSaveloader(true)
    const res = await paymentPlanStore?.updateCheck({ errorId: "updatecheck", data })
    if (res?.result == "Success") {
      // setThanksTitle(res?.result?.output?.statusMessage)
      handlePDCModalClose();
      setThanksModal(true);
      HappyMeterStore.openHappinessMeter();
      HappyMeterStore.setUPserviceID("7");
    }
    setSaveloader(false)

  }
  const loadSocialTable = async () => {
    setLoading(true);

    switch (props.index) {

      case 1:
        // await NocsRequests.getRecentRequests({
        //   errorId: "getRecentRequestsError",
        // });
        const data = {
          from: moment(fromValue).format("YYYY-MM-DD"),
          to: moment(toValue).format("YYYY-MM-DD"),
        };

        const res = await NocsRequests.getTrackRequests({
          errorId: "getTrackRequestsError",
          data,
        });
        setColumns(columnsRecentRequests);
        const filteredRecent = props.filter != null && props.filter != ""
          ? NocsRequests.nocs.filter((payment) => {
            const searchString = props.filter.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : NocsRequests.nocs;
        setRows(filteredRecent);
        break;

      case 2:
        await NocsRequests.getPDCPaymentPlans({
          errorId: "getPDCPaymentPlansError",
          data: User.info.personId as string,
        });
        setColumns(columnsPDC);
        setRows(NocsRequests.payments);
        break;

      case 3:
        await NocsRequests.getSocialCases({
          errorId: "getSocialCasesError",
          data: {
            from: moment(fromValue).format("YYYY-MM-DD"),
            to: moment(toValue).format("YYYY-MM-DD"),
          },
        });
        setColumns(columnsSocial);
        const filteredCases = props.filter != null && props.filter != ""
          ? NocsRequests.cases.filter((payment) => {
            const searchString = props.filter.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : NocsRequests.cases;

        setRows(filteredCases);
        break;

      case 4:
        await NocsRequests.getRefundHistory({ errorId: 'getRefundHistory' });
        setColumns(refundHistoryColumn);
        const filteredRefund = props.filter != null && props.filter != ""
          ? NocsRequests.refundHistory.filter((payment) => {
            const searchString = props.filter.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : NocsRequests.refundHistory;
        setRows(filteredRefund);
        break;

      default:
        break;
    }

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useLayoutEffect(() => {
    loadTable();
  }, [props.index]);

  useLayoutEffect(() => {
    loadSocialTable();
  }, [props.index, fromValue, toValue, props.filter]);
  // useEffect(() => {

  //   if (cardsStore.addedCardResponse.redirectRequired) {
  //     window.open(cardsStore.addedCardResponse.redirectUrl, '_self')
  //     handleCloseCardsPopupModal();
  //   }

  // }, [cardsStore.addedCardResponse])
  const handleCancelRequest = (refNumber:any) => {
    console.log("refNumber", refNumber)
    setCancelRequestNumber(refNumber);
    setCancelRequestModalOpen(true);
    }
  const handleServiceCancelRequest = async()=>{
    const res = await nocsRequestsStore.getServiceCancelationRequest({
      errorId: "serviceCancelationRequest",
      data: cancelRequestNumber,
    });
    if(res && res?.statusCode == 0){
          setCancelRequestModalOpen(false);
          NotifySuccess(General?.codeLabels[res?.statusMessage]?.label ? General?.codeLabels[res?.statusMessage]?.label : "Request cancelled successfully");
         loadSocialTable();
    }
    else{
      NotifyError(General?.codeLabels[res?.statusMessage]?.label ? General?.codeLabels[res?.statusMessage]?.label : "Something went wrong");
      setCancelRequestModalOpen(false);
    }
  }
  const handleUpdateMovein = async (refNumber: any) => {
    const payload ={
      caseId: refNumber,
      tenantPersonId: User.info.personId
      
    }
    const res = await nocsRequestsStore.getMoveInRegistrationDetails({
      errorId: "getMoveInRegistrationDetails",
      data: payload,
    });
    if(res && res?.statusCode == 0){
      setMoveinData(res);
      setMoveinCaseId(refNumber);
      setCaseReasons([]);
      // Fix: Pass the reasonCodes directly as a string, not as an object
      // if (res?.holdReasons) {
      //   const caseReasons = await nocsRequestsStore.getCaseReasons({
      //     errorId: "getCaseReasonsError",
      //     data: res.holdReasons, // Pass the reasonCodes directly as a string
      //   });
      //   if (caseReasons && caseReasons?.length > 0){
      //     setCaseReasons(caseReasons);
      //   }
        
      // }
      if(res?.caseStatus === "HOLD-CUSTACT" || res?.caseStatus === "HOLD-FLDINSP"){
        if (res?.holdReasons) {
        const caseReasons = await nocsRequestsStore.getCaseReasons({
          errorId: "getCaseReasonsError",
          data: res.holdReasons, // Pass the reasonCodes directly as a string
        });
        if (caseReasons && caseReasons?.length > 0){
          setCaseReasons(caseReasons);
        }
        
      }
      }
      if(res?.caseStatus === "REJECTED"){
        if(res?.rejectionReasons){
          const caseReasons = await nocsRequestsStore.getCaseReasons({
          errorId: "getCaseReasonsError",
          data: res.rejectionReasons, // Pass the reasonCodes directly as a string
        });
        if (caseReasons && caseReasons?.length > 0){
          setCaseReasons(caseReasons);
        }

        }
      }
      
      setMoveinUpdateModalOpen(true);
    }
  }
  const handleCloseMoveinUpdateModal = () => {
    setMoveinUpdateModalOpen(false);
    // loadSocialTable();
  }

  const handleUpdateSuccess = () => {
  loadSocialTable(); 
};
  const columnsBase: GridColDef[] = [
    {
      field: "refNumber",
      headerName: General?.codeLabels["cm_no_refnumber"]?.label ? General?.codeLabels["cm_no_refnumber"]?.label : "Ref Number",
      flex: 1, // Take full width by default
      headerAlign:'left',
      align:'left',
      minWidth: 100, // Set a minimum width for smaller screens
    },
    {
      field: "submissionDate",
      headerName: General?.codeLabels["cm_subdate"]?.label ? General?.codeLabels["cm_subdate"]?.label.replace(":", "") : "Submission Date",
      flex: 1, // Take full width by default
      headerAlign:'left',
      align:'left',
      minWidth: 100, // Set a minimum width for smaller screens
    },
    // {
    //   field: "accountNumber",
    //   // headerName: General?.codeLabels["cm_accountnopaymentstable"]?.label ? General?.codeLabels["cm_accountnopaymentstable"]?.label : "Account Number",
    //   headerName: General?.codeLabels["cm_sewerageid"]?.label ? General?.codeLabels["cm_sewerageid"]?.label +" / "+ General?.codeLabels["cm_mob_prclid"]?.label : "Sewerage Number / Parcel Id",
    //   flex: 1, // Take full width by default
    //   minWidth: 100, // Set a minimum width for smaller screens
    // },
    {
      field: "requestType",
      headerName: General?.codeLabels["cm_no_request_type"]?.label ? General?.codeLabels["cm_no_request_type"]?.label : "Request Type",
      description: "This column is a text and is not sortable.",
      sortable: false,
      flex: 1, // Take full width by default
      headerAlign:'left',
      align:'left',
      minWidth: 200, // Set a minimum width for smaller screens
    },
    {
      field: "Download",
      headerName: General?.codeLabels["cm_mob_download"]?.label ? General?.codeLabels["cm_mob_download"]?.label : "Download",
      flex: 1, // Take full width by default
      headerAlign:'left',
      align:'left',
      minWidth: 150, // Set a minimum width for smaller screens
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            <div>
              {!Object.fromEntries(Object.entries(params.row).map((a) => a))
                .nocReceipt ? (
                "N/A"
              ) : (
                <img
                  style={{ cursor: 'pointer' }}
                  src={pdf}
                  onClick={() => {
                    setLastBillingId(
                      Object.fromEntries(
                        Object.entries(params.row).map((a) => a)
                      ).nocReceipt
                    );
                    downloadBillPDF(params.row.id.toString(),params.row.refNumber);
                  }}
                  alt="PDF"
                />
              )}
            </div>
          </>
        );
      },
    },
  ];

  const columnsValidNocs: GridColDef[] = [
    ...columnsBase,
    // {
    //   field: "sewerageNumber",
    //   headerName: General?.codeLabels["cm_sewerageid"]?.label ? General?.codeLabels["cm_sewerageid"]?.label : "Sewerage Number",
    //   sortable: false,
    //   headerAlign:'left',
    //   align:'left',
    //   flex: 1,
    // },
  ];

  const columnsRecentRequests: GridColDef[] = [
    {
      field: "refNumber",
      headerName: General?.codeLabels["cm_no_refnumber"]?.label ? General?.codeLabels["cm_no_refnumber"]?.label : "Ref Number",
      flex: 1, // Take full width by default
      headerAlign:'left',
      align:'left',
      minWidth: 100, // Set a minimum width for smaller screens
    },
    {
      field: "submissionDate",
      headerAlign:'left',
      align:'left',
      headerName: General?.codeLabels["cm_subdate"]?.label ? General?.codeLabels["cm_subdate"]?.label.replace(":", "") : "Submission Date",
      flex: 1, // Take full width by default
      minWidth: 100, // Set a minimum width for smaller screens
    },

    {
      field: "typeDescription",
      headerName: General?.codeLabels["cm_no_request_type"]?.label ? General?.codeLabels["cm_no_request_type"]?.label : "Request Type",
      description: "This column is a text and is not sortable.",
      sortable: false,
      flex: 1, // Take full width by default
      headerAlign:'left',
      align:'left',
      minWidth: 200, // Set a minimum width for smaller screens
    },
    {
      field: "statusDescription",
      headerName: General?.codeLabels["cm_asreqstatustable"]?.label
        ? General?.codeLabels["cm_asreqstatustable"]?.label
        : "Status",
      sortable: false,
      headerAlign:'left',
      align:'left',
      flex: 1,
      renderCell: (params: any) => {
        return (
          <>
            <div
              style={{
                cursor: "pointer",
                display: "grid",
                placeItems: "left",
                width: "100%",
              }}
            >
                {params.row?.status == "Waiting for Approval" || params.row?.status == "WITHDRAWN" &&
                <div style={{display: "flex", alignItems: "center", gap: "10px",minWidth:"150px"}}>
                  <div style={{
                    padding: "5px 10px",
                    borderRadius: "4px",
                    backgroundColor: "#FFF4E5",
                    color: "#FF9800",
                    fontSize: "14px"
                  }}>
                    <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                  </div>
                </div>
                }
                {(params.row?.status === "Started" || params.row?.status === "STARTED") && 
                <div style={{display: "flex", alignItems: "center", gap: "10px",minWidth:"150px"}}>
                  <div style={{
                  padding: "5px 10px", 
                  borderRadius: "4px",
                  backgroundColor: "#FFF4E5",
                  color: "#FF9800",
                  fontSize: "14px"
                  }}>
                   <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                  </div>
                </div>
                }
                {(params.row?.status == "Completed" || params.row?.status == "COMPLETED" || params.row?.status == "COMPLETE" || params.row?.status == "APPROVED") &&
                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                  <div style={{
                    padding: "5px 10px",
                    borderRadius: "4px", 
                    backgroundColor: "#E8F5E9",
                    color: "#4CAF50",
                    fontSize: "14px"
                  }}>
                     <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                  </div>
                </div>
                }
                {(params.row?.status === "INPROGRESS" || params.row?.status === "Inprogress") &&
                <div style={{display: "flex", alignItems: "center", gap: "10px",minWidth:"150px"}}>
                  <div style={{
                  padding: "5px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#FFF4E5",
                  color: "#FF9800",
                  fontSize: "14px"
                  }}>
                   <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                  </div>
                </div>
                }
              {(params.row?.status === "REJECTED" || params.row?.status === "Rejected" || params.row?.status === "REJECT") &&
              <div style={{display: "flex", alignItems: "center", gap: "10px" , minWidth:"150px"}}>
                <div style={{
                  padding: "5px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#FFEBEE", 
                  color: "#F44336",
                  fontSize: "14px"
                }}>
                   <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                </div>
              </div>
              }
              {(params.row?.status === "WAITPAYMENT" || params.row?.status === "WaitPayment") &&
              <div style={{display: "flex", alignItems: "center", gap: "10px" , minWidth:"150px"}}>
                <div style={{
                  padding: "5px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#E3F2FD", // light blue
                  color: "#1976D2", // blue text for contrast
                  fontSize: "14px"
                }}>
                   <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                </div>
              </div>
              }
              {/* {(params.row?.status === "WAITPAYMENT" || params.row?.status === "WaitPayment") &&
              <div style={{display: "flex", alignItems: "center", gap: "10px" , minWidth:"150px"}}>
                <div style={{
                  padding: "5px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#E3F2FD", // light blue
                  color: "#1976D2", // blue text for contrast
                  fontSize: "14px"
                }}>
                  {params.row?.status}
                </div>
              </div>
              } */}
              {(params.row?.status === "PENDING REVIEW" || params.row?.status === "PENDINGDUE") &&
              <div style={{display: "flex", alignItems: "center", gap: "10px" , minWidth:"150px"}}>
                <div style={{
                  padding: "5px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#FFF4E5", 
                  color: "#F44336",
                  fontSize: "14px"
                }}>
                   <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                </div>
              </div>
              }
              {(params.row?.status === "HOLD-CUSTACT") &&
                <div style={{display: "flex", alignItems: "center", gap: "10px" , minWidth:"150px"}}>
                <div style={{
                  padding: "5px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#FFEBEE", // light red background
                  color: "#F44336", // red text
                  fontSize: "14px"
                }}>
                   <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                </div>
                </div>
              }
              {!(
                params.row?.status == "Waiting for Approval" ||
                params.row?.status == "WITHDRAWN" ||
                params.row?.status === "Started" ||
                params.row?.status === "STARTED" ||
                params.row?.status == "Completed" ||
                params.row?.status == "COMPLETED" ||
                params.row?.status == "COMPLETE" ||
                params.row?.status == "APPROVED" ||
                params.row?.status === "INPROGRESS" ||
                params.row?.status === "Inprogress" ||
                params.row?.status === "REJECTED" ||
                params.row?.status === "Rejected" ||
                params.row?.status === "REJECT" ||
                params.row?.status === "PENDING REVIEW" ||
                params.row?.status === "PENDINGDUE" ||
                params.row?.status === "HOLD-CUSTACT"
              ) && (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "150px" }}>
                  <div
                    style={{
                      padding: "5px 10px",
                      borderRadius: "4px",
                      backgroundColor: "#FFF4E5",
                      color: "#FF9800",
                      fontSize: "14px",
                    }}
                  >
                    <span
                      title={params.row?.statusDescription}
                      style={{
                        display: "inline-block",
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {params.row?.statusDescription}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </>
        );
      },
    },
    // {
    //   field:"Actions",
    //   headerName:"Actions",
    //   description: "This column is a text and is not sortable.",
    //   sortable: false,
    //   flex: 1, // Take full width by default
    //   headerAlign:'left',
    //   align:'left',
    //   minWidth: 200, // Set a minimum width for smaller screens
    //   renderCell: (params: any) => {
    //     // console.log("params", params)
    //     if (params.row?.status === "WAITPAYMENT" || params.row?.status === "WaitPayment") {
    //       return (
    //         <button
    //           style={{
    //             padding: "6px 16px",
    //             background: "#101e8e",
    //             color: "#fff",
    //             border: "none",
    //             borderRadius: "4px",
    //             cursor: "pointer",
    //             fontSize: "14px"
    //           }}
    //           onClick={() => navigate(`/getdispute/${params.row?.refNumber}`)}
    //         >
    //           Go to payment
    //         </button>
    //       );
    //     }
    //     return null;
    //   }
    // }
    {
      field:"Actions",
      headerName:General?.codeLabels["cm_actions"]?.label,
      description: "This column is a text and is not sortable.",
      sortable: false,
      flex: 1, // Take full width by default
      headerAlign:'left',
      align:'left',
      minWidth: 300, // Set a minimum width for smaller screens
      renderCell: (params: any) => {
        
        // For null requestType
        if (params.row?.requestType == "MOVEIN") {
         const buttons = [];
  const { status, cancellable, userAssigned, refNumber } = params.row || {};

  // 1. Logic for Cancel Request Button
  let showCancel = false;

  if (cancellable) {
    if (status === "HOLD-CUSTACT") {
      // Rule: If HOLD-CUSTACT, we don't care about userAssigned
      showCancel = true;
    } else if (!userAssigned) {
      // Rule: For all other statuses, userAssigned must be false
      showCancel = true;
    }
  }

  if (showCancel) {
    buttons.push(
      <button
        key="cancel"
        style={{
          padding: "6px 10px",
          background: "#101e8e",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "14px",
          marginRight: "8px",
          width:"120px",
          whiteSpace: "nowrap", // Prevents the text from wrapping to 2 lines
          height: "36px",
        }}
        onClick={() => handleCancelRequest(refNumber)}
      >
        {General?.codeLabels["cm_cancel_request"]?.label || "Cancel Request"}
      </button>
    );
  }

  // 2. Logic for View Details Button
  const showViewDetails = ["HOLD-CUSTACT", "HOLD-FLDINSP", "REJECTED"].includes(status);

  if (showViewDetails) {
    buttons.push(
      <button
        key="view"
        style={{
          padding: "6px 10px",
          background: "#101e8e",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "14px",
          width:"120px",
          whiteSpace: "nowrap", // Prevents the text from wrapping to 2 lines
    height: "36px",
        }}
        onClick={() => handleUpdateMovein(refNumber)}
      >
        {General?.codeLabels["cm_view_details"]?.label || "View Details"}
      </button>
    );
  }

  return buttons.length > 0 ? (
    <div style={{ display: "flex", alignItems: "center" }}>
      {buttons}
    </div>
  ) : null;
        }
        
        // For other specific request types
        if (params.row?.requestType == "MVOUTDISPUTE" || 
            params.row?.requestType == "OUT NOC" || 
            params.row?.requestType == "MOVEOUTAPPRV") {
          
          // Only show cancel button if cancellable
          if (params?.row?.cancellable) {
            return (
              <button
                style={{
                  padding: "6px 16px",
                  background: "#101e8e",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px"
                }}
                onClick={() => handleCancelRequest(params.row.refNumber)}
              >
               {General?.codeLabels["cm_cancel_request"]?.label ? General?.codeLabels["cm_cancel_request"]?.label : "Cancel Request"}

              </button>
            );
          } else {
            // Don't show any button for these request types when not cancellable
            return null;
          }
        }
        if (params.row?.status === "WAITPAYMENT" || params.row?.status === "WaitPayment") {
          return (
            <button
              style={{
                padding: "6px 16px",
                background: "#101e8e",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px"
              }}
              onClick={() => navigate(`/getdispute/${params.row?.refNumber}`)}
            >
              Go to payment
            </button>
          );
        }
        
        return null;
      }
    }
  ];

  const columnsPDC: GridColDef[] = [
    {
      field: "paymentPlanID",
      headerName: General?.codeLabels["cm_pdc_paymentplanid"]?.label
        ? General?.codeLabels["cm_pdc_paymentplanid"]?.label
        : "Payment Plan ID",
      flex: 1,
      headerAlign:'left',
      align:'left',
      editable: false,
    },
    {
      field: "createdOn",
      headerName: General?.codeLabels["cm_created_on"]?.label
        ? General?.codeLabels["cm_created_on"]?.label
        : "Created On",
      flex: 1,
      headerAlign:'left',
      align:'left',
      editable: false,
    },
    {
      field: "numberOfCheques",
      headerName: General?.codeLabels["cm_billsnumberpdctable"]?.label
        ? General?.codeLabels["cm_billsnumberpdctable"]?.label
        : "Number of Cheques",
      flex: 1,
      headerAlign:'left',
      align:'left',
      editable: false,
    },
    {
      field: "status",
      headerName: General?.codeLabels["cm_asreqstatustable"]?.label
        ? General?.codeLabels["cm_asreqstatustable"]?.label
        : "Status",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      headerAlign:'left',
      align:'left',
      flex: 1,
    },
    {
      field: "amount",
      headerName: General?.codeLabels["cm_pdc_amountinaed"]?.label
        ? General?.codeLabels["cm_pdc_amountinaed"]?.label
        : "Amount(AED)",
      flex: 1,
      editable: false,
      headerAlign: 'left',
      align: 'right'
    },
    {
      field: "Actions",
      headerName: General?.codeLabels["cm_label_appointment_actions"]?.label
        ? General?.codeLabels["cm_label_appointment_actions"]?.label
        : "Actions",
      flex: 1,
      sortable: false,
      headerAlign:'left',
      align: "center",
      renderCell: (params: any) => {
        return (
          <>
            <div
              style={{
                display: "grid",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "50%",
                  marginLeft:'1rem'
                }}
              >
                <img
                  src={View}
                  alt="View"
                  onClick={() => handlePDCModalOpen(params.row.paymentPlanID)}
                  style={{ cursor: "pointer",marginLeft:'5px' }}
                />

                {params.row.status === "Payment Pending" ||
                  params.row.status === "Created" ? (
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    onClick={() => handleDeletePDCModalOpen(params.row.paymentPlanID)}
                    style={{ cursor: "pointer",marginLeft:'5px' }}
                  />
                ) : null}
                {params.row.status === "Payment Pending" ? (
                  <button style={{ fontSize: `${General.accessibility.fontSize}rem`, border: "1px solid rgb(16, 30, 142)", color: contrast?.contrastColor ? contrast?.contrastColor : "rgb(16, 30, 142)", background: contrast?.contrastBackground ? contrast?.contrastBackground : "white", padding: "2px 20px" ,marginLeft:'5px'}} onClick={() => handlePay(params.row.paymentPlanID)}>{payLoader ? <Spinner width="15px" height="15px" /> : General?.codeLabels["cm_pay"]?.label ? General?.codeLabels["cm_pay"]?.label : "Pay"}</button>
                ) : null}
              </div>
            </div>
          </>
        );
      },
    },
  ];

  const columnsSocial: GridColDef[] = [
    {
      field: "date",
      headerName: General?.codeLabels["cm_date"]?.label
        ? General?.codeLabels["cm_date"]?.label
        : "Date",
      flex: 1,
      headerAlign:'left',
      align:'left',
      editable: false,
    },
    {
      field: "requestNumber",
      headerName: General?.codeLabels["cm_requestno"]?.label
        ? General?.codeLabels["cm_requestno"]?.label
        : "DaRequest Numberte",
      flex: 1,
      editable: false,
      headerAlign:'left',
      align:'left',
    },
    {
      field: "parcelNumber",
      headerName: General?.codeLabels["cm_parcelnumber"]?.label
        ? General?.codeLabels["cm_parcelnumber"]?.label
        : "cm_parcelnumber",
      flex: 1,
      editable: false,
      headerAlign:'left',
      align:'left',
    },
    {
      field: "totalDue",
      headerName: `${General?.codeLabels["cm_total_due_amount"]?.label
        ? General?.codeLabels["cm_total_due_amount"]?.label
        : "Total Due"} ${General?.codeLabels['cm_mob_aed']?.label ? General?.codeLabels['cm_mob_aed']?.label : "AED"}`,
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 1,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: "approvedAmount",
      headerName: `${General?.codeLabels["cm_approvedamount"]?.label
        ? General?.codeLabels["cm_approvedamount"]?.label
        : "Approved Amount"} ${General?.codeLabels['cm_mob_aed']?.label ? General?.codeLabels['cm_mob_aed']?.label : "AED"}`,
      flex: 1,
      editable: false,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: "status",
      headerName: General?.codeLabels["cm_asreqstatustable"]?.label
        ? General?.codeLabels["cm_asreqstatustable"]?.label
        : "Status",
      flex: 1,
      editable: false,
      headerAlign:'left',
      align:'left',
    },
    {
      field: "Actions",
      headerName: General?.codeLabels["cm_label_appointment_actions"]?.label
        ? General?.codeLabels["cm_label_appointment_actions"]?.label
        : "Actions",
      flex: 1,
      headerAlign:'left',
      align:'left',
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            <div
              onClick={() =>
                handleSocialCaseModalOpen(params.row.requestNumber, params.row.status,params.row.statusId)
              }
              style={{
                cursor: "pointer",
                display: "grid",
                placeItems: "left",
                width: "100%",
              }}
            >
              {props.children}
            </div>
          </>
        );
      },
    },
  ];


  const refundHistoryColumn: GridColDef[] = [
    {
      field: "date",
      headerName: General?.codeLabels["cm_date"]?.label
        ? General?.codeLabels["cm_date"]?.label
        : "Date",
      flex: 1,
      headerAlign:'left',
      align:'left',
      editable: false,
    },
    {
      field: "referenceNumber",
      headerName: General?.codeLabels["cm_forms_refno"]?.label
        ? General?.codeLabels["cm_forms_refno"]?.label
        : "Reference Number",
      flex: 1,
      headerAlign:'left',
      align:'left',
      editable: false,
    },

    {
      field: "totalDue",
      headerName: `${General?.codeLabels["cm_amount"]?.label
        ? General?.codeLabels["cm_amount"]?.label
        : "Amount"} ${General?.codeLabels['cm_mob_aed']?.label ? General?.codeLabels['cm_mob_aed']?.label : "AED"}`,
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },

    {
      field: "status",
      headerName: General?.codeLabels["cm_noc_status"]?.label
        ? General?.codeLabels["cm_noc_status"]?.label
        : "Status",
      flex: 1,
      headerAlign:'left',
      align:'left',
      editable: false,
    },
  ];

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  return (
    <>
      <Box
        sx={{
          height: "80vh",
          width: isLargeScreen ? "94%" : "100%",
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "white",
          color: contrast?.contrastColor ? contrast?.contrastColor : "",
          margin: "auto",
        }}
      >
        <Box
          sx={{
            width: props?.OtherWidth ?? "96%",
            paddingTop: "2rem",
            paddingBottom: "2rem",
            display: "flex",
            flexDirection: isLargeScreen ? "row" : "column",
            justifyContent: "space-between",
            gap: {
              xs: "20px",
              md: "0px",
            },
            margin: "auto",
          }}
        >
          <Box
            id={"dateContainers"}
            sx={{
              display: props.index == 3 ? "flex" : "flex",
              flex: 3,
              gap: "1rem",
              height: { xs: 0, md: "3rem" },
              justifyContent: "space-between",
            }}
          >
            {props.index == 3 || props.index == 1 || props?.index == 4 ? (
              <>
                {props?.index != 4 && <Box
                  sx={{
                    display: "flex",
                    width: {
                      xs: "100%",
                      lg: "200px",
                    },
                    alignItems: "center",
                    flexDirection: { xs: "row", md: "row" }, // Change to column below xs (768px)
                    gap: {
                      xs: "10px",
                      md: "0px",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",

                      width: "100%",
                      gap: {
                        xs: "10px",
                        md: "0px",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        marginInlineEnd: {
                          xs: "0px",
                          md: "10px",
                        },
                        color: contrast?.contrastColor || "",
                      }}
                      className="calendarItems pt-lg-0 pt-0"
                    >
                      {General?.codeLabels["cm_from"]?.label
                        ? General?.codeLabels["cm_from"]?.label
                        : "From"}
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <MobileDatePicker
                        disableFuture={true}
                        className="calendar-style"
                        inputFormat="DD-MM-YYYY"
                        value={fromValue}
                        onChange={handleFromChange}
                        renderInput={(params: TextFieldProps) => {
                          return (
                            <TextField  sx={{
                            width:General?.isLargeScreen ? '200px':'140px'
                          }}
                          className="text-field-cal" {...params} />
                          );
                        }}
                      />
                    </LocalizationProvider>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      gap: {
                        xs: "10px",
                        md: "0px",
                      },
                      marginRight:{xs:'0.5rem'}
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                        marginLeft: {
                          xs: "0px",
                          md: "10px",
                        },
                        color: contrast?.contrastColor || "",
                      }}
                      className="calendarItems pt-lg-0 pt-1 px-2"
                    >
                      {General?.codeLabels["cm_to"]?.label
                        ? General?.codeLabels["cm_to"]?.label
                        : "To"}
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <MobileDatePicker
                        disableFuture={true}
                        className="calendar-style"
                        inputFormat="DD-MM-YYYY"
                        value={toValue}
                        onChange={handleToChange}
                        renderInput={(params: TextFieldProps) => {
                          return <TextField {...params} sx={{
                            width:General?.isLargeScreen ? '200px':'140px'
                          }}/>;
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>}

                {isLargeScreen && <>{props.children4}</>}
              </>
            ) : (
              props.children3
            )}
          </Box>

          {isLargeScreen ? (
            <div className="d-flex justify-content-end ">{props.children2}</div>
          ) : null}
        </Box>
        {!isLargeScreen && (
          <div
            style={{ width: "100%" }}
            className="d-flex justify-content-center "
          >
            {props.children4}
          </div>
        )}
        {!isLargeScreen && (
          <div
            style={{ width: "100%", marginTop: "0.5rem" }}
            className="d-flex justify-content-center "
          >
            {props.children2}
          </div>
        )}

        {isLargeScreen ? (
          loading ? (
            <Spinner />
          ) : (
            <DataGrid
              loading={loading}
              rows={rows}
              columns={columns}
              hideFooter={true}
              disableSelectionOnClick={true}
              className='NocReqText'
              // components={{
              //   Toolbar: GridToolbar,
              // }}
              sx={{
                "& .MuiDataGrid-columnSeparator": { display: "none" },

                color: "#101e8e",
                width: props?.datagridWidth ?? "96%",
                "@media screen and (max-width: 768px)": {
                  width: "100%", // Adjust width for smaller screens
                },
                height: "65vh",
                margin: "auto",
                border: "none",
                "& .MuiSvgIcon-root": {
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight:"bolder !important",
                },
                "& .MuiDataGrid-cell,.MuiDataGrid-row": {
                  whiteSpace: "normal !important",
                },
                "& .MuiDataGrid-columnHeaders": {
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: props?.tabBackgroundColor ?? "#E5EFF2",
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                },
                "& .MuiDataGrid-columnHeadersInner": {
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "FFFFFF",
                },
                "& .Mui-selected": {
                  backgroundColor: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#E5EFF2",
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                },
                "& .MuiButtonBase-root ": {
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                },

                '[data-field="amountToPay"]': {
                  margin: "auto",
                  "& .MuiDataGrid-cellContent": {
                    backgroundColor: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#E5EFF2",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    textAlign: "right",
                    width: "100px",
                    height: "100%",
                    padding: "5px",
                    border: "1px solid lightgray",
                    // fontSize:'2rem'
                  },
                },
              }}
            />
          )
        ) : loading ? (
          <Spinner />
        ) : (
          <NOCMobileDataGrid 
           downloadBillPDF={downloadBillPDF}
           handlePay={handlePay} 
           handleSocialCaseModalOpen={handleSocialCaseModalOpen} 
           handlePDCModalOpen={handlePDCModalOpen} 
           rows={rows} 
           indexes={props.index} 
           handleCancelRequest={handleCancelRequest}
           handleUpdateMovein={handleUpdateMovein}
          />
        )}
      </Box>

      <Modal
        open={socialCaseModalOpen}
        onClose={handleSocialCaseModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <SocialCaseModal
          onCross={handleSocialCaseModalClose}
          details={NocsRequests.caseDetails}
          status={socialCaseStatus}
          statusId={statusId}
        />
      </Modal>

      <Modal
        open={pdcModalOpen}
        onClose={handlePDCModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <PDCModal
          onClose={handlePDCModalClose}
          pdcDetails={NocsRequests.pdcDetails}
          // checkDetails={NocsRequests.pdcDetails?.checkDetails}
          getPDCConnectorAccountList={handleGetPDCConnectorAccountList}
          getPDCServiceAccountList={handleGetPDCServiceAccountList}
          serviceAccounts={NocsRequests.serviceAccounts}
          connectorAccounts={NocsRequests.connectorAccounts}
          payNowClicked={handlePayNowClicked}
          Submit={handleSave}
          saveloader={saveloader}
        />
      </Modal>
      <Modal
        open={delModalOpen}
        onClose={closeDelModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DeleteModal
          onClose={closeDelModal}
          delData={deletePdc}
          delLoader={delLoader}
        />
      </Modal>
      <Modal open={cardsPopupModal} onClose={handleCloseCardsPopupModal}>
        <div>
          <CardsPopup
            onClose={handleCloseCardsPopupModal}
            makePayment={handleMakePayment}
            fromAutoPay={false}
          />
        </div>
      </Modal>
      <Modal open={thanksModal} onClose={() => setThanksModal(false)}>
        <TabContainer
          style={{
            width: General?.isLargeScreen ? "40%" : "100%",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            alignSelf: "flex-start",
            minHeight: "40vh",
            gap: "0",
            background: "#fff"
          }}
        >
          <ThankyouHeader>
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                 <path d="M23 0C10.317 0 0 10.317 0 23C0 35.683 10.317 46 23 46C35.683 46 46 35.683 46 23C46 18.44 44.6603 14.1893 42.3633 10.6113L40.9941 12.2285C42.8891 15.3825 44 19.06 44 23C44 34.579 34.579 44 23 44C11.421 44 2 34.579 2 23C2 11.421 11.421 2 23 2C28.443 2 33.3939 4.09977 37.1289 7.50977L38.4375 5.96484C34.3525 2.25984 28.935 0 23 0ZM41.2363 5.75391L21.9141 28.5547L13.7812 20.9688L12.418 22.4316L22.084 31.4473L42.7637 7.04688L41.2363 5.75391Z"
                fill={General?.colorClass?General?.colorClass:"#62AA51"}/>
              </svg>
            <h1>
              {General?.codeLabels["cm_thankyou"]?.label !== undefined
                ? General?.codeLabels["cm_thankyou"]?.label
                : "Thank you !!!"}
            </h1>
          </ThankyouHeader>
          <ThankyouMessage>
            <p>{General?.codeLabels["cm_as_label_successmsg"]?.label ? General?.codeLabels["cm_as_label_successmsg"]?.label : "Successfully processed the reques"}</p>

            <button
              onClick={() => setThanksModal(false)}
              style={{ background: "#101e8e", color: "#fff" }}
            >
              {General?.codeLabels["cm_close"]?.label ? General?.codeLabels["cm_close"]?.label : 'close'}

            </button>
          </ThankyouMessage>
        </TabContainer>
      </Modal>
      <Modal
        open={cancelRequestModalOpen}
        onClose={() => {
          setCancelRequestModalOpen(false);
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
         <CancelRequest
            onClose={() => setCancelRequestModalOpen(false)}
            cancelData={() => {handleServiceCancelRequest()}}
          />
      </Modal>
      <Modal
        open={moveinUpdateModelOpen}
        onClose={() => {
          setMoveinUpdateModalOpen(false);
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
         <MoveinRequestUpdations
           open={true}
           onClose={() =>handleCloseMoveinUpdateModal()}
           initialData={moveinData}
           caseId={moveinCaseId}
           caseReasons={caseReasons}
           onSuccess={handleUpdateSuccess}
         />
      </Modal>
    </>
  );
};

export default observer(NocGrid);
